import { useMemo } from 'react';
import { ListChecks } from 'lucide-react';

import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

const STATUS_OPTIONS = [
  { id: 'NEW', value: 'NEW', label: 'New' },
  { id: 'OPEN', value: 'OPEN', label: 'Open' },
  { id: 'PENDING', value: 'PENDING', label: 'Pending' },
  { id: 'ON_HOLD', value: 'ON_HOLD', label: 'On Hold' },
];

export function StatusFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const selected = useMemo(() => {
    const ticketStatus = filters.ticketStatus ?? [];
    const validIds = new Set(STATUS_OPTIONS.map(({ id }) => id));
    return ticketStatus.filter((id) => validIds.has(id));
  }, [filters.ticketStatus]);

  return (
    <MultipleChoiceFilter
      items={STATUS_OPTIONS}
      label="Status"
      name="ticketStatus"
      onFilterChange={({ ticketStatus }) => updateFilters({ ticketStatus })}
      onlyUpdateOnChange
      value={selected.join(',')}
      variant="ghost"
      leftIcon={<ListChecks size={iconSize.md} />}
      rightIcon={undefined}
    />
  );
}
